import { useState, useCallback } from "react";

export const useStartStrategyModal = () => {
  const [open, setOpen] = useState(false);
  const [interaction, setInteraction] = useState<any>(null);

  const openModal = useCallback((interactionData: any) => {
    // Pass full interactions so each connection still has all rpcs (e.g. get_beta for use_endpoint).
    // VerticalTabs filters which tabs are shown (Create Spread Bot only) via onlyShowRpcLabels.
    setInteraction(interactionData);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
    setInteraction(null);
  }, []);

  return {
    open,
    interaction,
    openModal,
    closeModal,
  };
};